import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions";
import {ActivatedRoute} from "@angular/router";
import {ApolloQueryObservable} from "apollo-angular";
import {SensorService} from "../../services/sensor.service";
import {Observable} from "rxjs/Observable";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SensorFormComponent} from "../../components/sensor-form/sensor-form.component";
import {MessageType} from "../../../shared/redux-store/session";
import {map} from "rxjs/operators";

@Component({
  selector: 'vb-sensor-details',
  templateUrl: './sensor-details.component.html',
  styleUrls: ['./sensor-details.component.css']
})
export class SensorDetailsComponent extends AbstractVisbosComponent implements OnInit {

  private sensor$: ApolloQueryObservable<any>;
  public sensor: any;
  public logEntriesSeriesData = [];

  filterControl: FormGroup;
  sensorControl: FormGroup;

  isSensorDataCollapsed: boolean = true;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private route: ActivatedRoute,
              private sensorService: SensorService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.sensorControl = SensorFormComponent.initControl(this.fb);

    this.filterControl = this.fb.group({
      start_date: [],
      end_date: []
    });

    let sensorCuid$: Observable<string> = this.route.params.pipe(map(params => params.sensorCuid));
    this.sensor$ = this.sensorService.getSensorDetails(sensorCuid$, false, this.filterControl.get('start_date').valueChanges, this.filterControl.get('end_date').valueChanges);
    this.addComponentData(this.sensor$);
    this.addSubscription(this.sensor$.subscribe(res => {
      this.sensor = res.data.sensors[0];
      this.logEntriesSeriesData = this.getLogEntriesAsSeriesData();
    }));

    this.filterControl.patchValue({start_date: null, end_date: null}); // REquired to trigger initial loading of sensor details

  }

  public getLogEntriesAsSeriesData() {
    let entries = this.sensor.log_entries;

    let seriesData = [];

    for (let entry of entries) {
      seriesData.push({
        'name': new Date(entry.created_at),
        'value': entry.temperature_value,
        'highlight': entry.is_critical
      })
    }

    return [{
      'name': this.sensor.label,
      'series': seriesData
    }];
  }

  onUpdateSensorClicked() {
    let cuid = this.sensorControl.get('cuid').value;
    let input = this.sensorControl.getRawValue();

    this.sensorService.updateTempratureSensor(cuid, input).toPromise()
      .then(res => this.sessionActions.pushMessage("Sensor-Daten erfolgreich gespeichert!", MessageType.SUCCESS, "Sensoren"))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Speichern der Sensor-Daten, bitte wenden Sie sich an den Support!", "Sensoren"));
  }

}



// WEBPACK FOOTER //
// ./src/app/sensors/views/sensor-details/sensor-details.component.ts